import { asNumber, formatString, isDefined } from './utils';

export const requiredValidator = {
  key: 'valueMissing',
  message: 'This field is required',
  isValid: ({ required, value }) => (required ? !!value : true),
};

export const requiredNumberValidator = {
  key: 'valueMissing',
  message: 'This field is required',
  isValid: ({ required, value }) => (required ? isDefined(value) : true),
};

export const minLengthValidator = {
  key: 'tooShort',
  message: ({ minLength }) =>
    formatString('Entry should be at least {0} character(s) long', minLength),
  isValid: ({ minLength, value }) =>
    minLength ? value.length >= minLength : true,
};

export const maxLengthValidator = {
  key: 'tooLong',
  message: ({ maxLength }) =>
    formatString(
      'Entry should be no more than {0} character(s) long',
      maxLength
    ),
  isValid: ({ maxLength, value }) =>
    maxLength ? value.length <= maxLength : true,
};

export const patternValidator = {
  key: 'patternMismatch',
  message: 'Entry does not match the required pattern',
  isValid: ({ pattern, value }) =>
    pattern ? new RegExp(pattern, 'u').test(value) : true,
};

export const minValidator = {
  key: 'rangeUnderflow',
  message: ({ min }) =>
    formatString('A value of at least {0} should be entered', min),
  isValid: ({ min, value }) =>
    isDefined(min)
      ? isDefined(value) && asNumber(value) >= asNumber(min)
      : true,
};

export const maxValidator = {
  key: 'rangeOverflow',
  message: ({ max }) =>
    formatString('A value no more than {0} should be entered', max),
  isValid: ({ max, value }) =>
    isDefined(max)
      ? isDefined(value) && asNumber(value) <= asNumber(max)
      : true,
};

export const stepValidator = {
  key: 'stepMismatch',
  message: 'Value does not conform to step constraint',
  isValid: ({ min, step, value }) =>
    isDefined(step)
      ? (asNumber(value) - asNumber(min)) % asNumber(step, 1) === 0
      : true,
};

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const emailValidator = {
  key: 'typeMismatch',
  message: 'A valid email address should be entered',
  isValid: ({ value }) => emailRegex.test(value),
};

export const urlValidator = {
  key: 'typeMismatch',
  message: 'A valid url address should be entered',
  isValid: ({ value }) => URL.canParse(value),
};

export const customValidator = {
  key: 'customError',
  message: 'this is the same as my dogs name!!!',
  isValid: ({ value }) => value !== 'Richard Nixon',
};

export const maxWordValidator = {
  key: 'customError',
  message: ({ maxWords }) =>
    isDefined(maxWords)
      ? formatString('Entry should be no more than {0} word(s) long', maxWords)
      : '',
  isValid: ({ maxWords, value }) => {
    if (!isDefined(maxWords) || !isDefined(value)) {
      return true;
    }
    const wordCount = value
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    return wordCount <= Number(maxWords);
  },
};

export const minWordValidator = {
  key: 'customError',
  message: ({ minWords }) =>
    isDefined(minWords)
      ? formatString('Entry should be at least {0} word(s) long', minWords)
      : '',
  isValid: ({ minWords, value }) => {
    if (!isDefined(minWords) || !isDefined(value)) {
      return true;
    }
    const wordCount = value
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
    return wordCount >= Number(minWords);
  },
};
